import React, { useState } from "react";
import { Row, Col, Modal, Button, Input, notification } from "antd";
import styles from "./GroceryModals.module.scss";
import textStyles from "../../Shared/Styles/TextStyles.module.scss";
import closeIconGrey from "../../../assets/images/closeIconGrey.svg";
import { addTempGroceryCart } from "../../../services/GroceryService";
import { useGroceryCtx } from "../../../context/GroceryContext";

type Props = {
  isVisible: boolean;
  setVisibility: Function;
  serviceUserPersonId: number;
};

function ShoppingCartDeliveryInstructionsModal({
  isVisible,
  setVisibility,
  serviceUserPersonId,
}: Props) {
  const { deliveryNoteCtx } = useGroceryCtx();
  const [deliveryNote, setDeliveryNote] = deliveryNoteCtx;
  const [instructions, setInstructions] = useState<string>(deliveryNote);

  async function handleAddDeliveryInstruction() {
    setDeliveryNote(instructions.trim());
    setVisibility(false);
    try {
      await addTempGroceryCart({
        serviceUserPersonId: serviceUserPersonId,
        deliveryNote: instructions.trim(),
      });
    } catch {
      notification.error({
        message: "Failed to delete items in the cart.",
      });
    }
  }

  function handleInstructionsChange(value: string) {
    const instructions = value.replace(/\s\s+/g, " ");
    instructions.trimStart() === instructions && setInstructions(instructions);
  }

  return (
    <Modal
      visible={isVisible}
      className={styles.deliveryInstructionsModalContainer}
      centered
      footer={
        <Row className={styles.cartModalBtnsAlignment} gutter={[8, 8]}>
          <Col className={styles.btnFlex1}>
            <Button
              className={`${styles.cancelBtn} ${styles.cancelInstructionsBtns}`}
              onClick={() => setVisibility(false)}
            >
              Cancel
            </Button>
          </Col>
          <Col className={styles.btnFlex3}>
            <Button
              className={`${styles.continueBtn} ${styles.addInstructionsBtns} `}
              onClick={handleAddDeliveryInstruction}
              disabled={instructions ? instructions.length === 0 : true}
            >
              Add instruction
            </Button>
          </Col>
        </Row>
      }
    >
      <Row className={`${textStyles.boldText16} ${styles.instructionsHeading}`}>
        Delivery instructions
        <Button
          onClick={() => setVisibility(false)}
          className={styles.instructionsCloseBtn}
        >
          <img src={closeIconGrey} alt="close_delivery_instructions" />
        </Button>
      </Row>
      <Row className={`${textStyles.normalText14} ${styles.marginDown8}`}>
        Provide any instructions for your delivery below:
      </Row>
      <Row>
        <Input
          maxLength={255}
          placeholder="Please, ring door bell."
          className={`${styles.instructionsInputField} ${textStyles.normalText14}`}
          value={instructions}
          onChange={(e) => handleInstructionsChange(e.target.value)}
        />
      </Row>
    </Modal>
  );
}

export default ShoppingCartDeliveryInstructionsModal;
